import { createSelector } from 'reselect';
import * as Constants from '../Constants';

const shippingInfoData = (state) =>
  state?.shippingInfo?.ShippingInfoDetails?.lines && state.shippingInfo.ShippingInfoDetails.lines.length > 0
    ? state.shippingInfo.ShippingInfoDetails.lines
    : {};

export const selectShippingData = createSelector(shippingInfoData, (checkout) => {
  const shippingData = checkout || [];

  if (shippingData && shippingData.length) {
    for (let i = 0, shippingLength = shippingData.length; i < shippingLength; i++) {
      // Set the Line shipment to current iteration
      const shipment = shippingData[i];

      if (shipment && shipment.shippingOptions && shipment.shippingOptions.length > 0) {
        // Check if ISPU option is present for this line
        const ispuIndex = shipment.shippingOptions.findIndex((option) => option.shippingOptionId === 'ISPU');

        // ISPU option already exists for this line's shipping options
        if (ispuIndex !== -1) {
          // Add additional information to this existing ISPU node
          shipment.shippingOptions[ispuIndex] = {
            ...shipment.shippingOptions[ispuIndex],
            ...Constants.ISPU_OPTION,
          };
        } else if (shipment.ispuEligible) {
          // Add ISPU option for this line's shippingOptions as the first item
          shipment.shippingOptions.push(Constants.ISPU_OPTION);
        }
      }
    }
  }
  return shippingData;
});

export const getLineLevelSplitShipmentFlag = createSelector(selectShippingData, (shippingData) => {
  const lineLevelSplitShipment = shippingData && shippingData.find((item) => item.lineLevelShipment === true);
  return (lineLevelSplitShipment && lineLevelSplitShipment.lineLevelShipment) || false;
});

export const getLineLevelshipTogetherPrefFlag = createSelector(selectShippingData, (shippingData) => {
  const lineLevelSplitShipment = shippingData && shippingData.find((item) => item.shipTogetherPref === true);
  return (lineLevelSplitShipment && lineLevelSplitShipment.shipTogetherPref) || false;
});

const shippingInfoDataFun = (state) => (state?.checkout?.shipment?.lines && state.checkout?.shipment) || {};

export const selectShippingDataFun = createSelector(shippingInfoDataFun, (checkout) => {
  const shippingData = checkout || [];

  if (shippingData) {
    // Set the Line shipment to current iteration
    const shipment = shippingData?.lines?.newLine1;

    if (shipment && shipment.shippingOptions && shipment.shippingOptions.length > 0) {
      // Check if ISPU option is present for this line
      const ispuIndex = shipment.shippingOptions.findIndex((option) => option.shippingOptionId === 'ISPU');

      // ISPU option already exists for this line's shipping options
      if (ispuIndex !== -1) {
        // Add additional information to this existing ISPU node
        shipment.shippingOptions[ispuIndex] = {
          ...shipment.shippingOptions[ispuIndex],
          ...Constants.ISPU_OPTION,
        };
      } else if (shipment.ispuEligible) {
        // Add ISPU option for this line's shippingOptions as the first item
        shipment.shippingOptions.push(Constants.ISPU_OPTION);
      }
    }
  }
  return shippingData;
});

export const getLineLevelSplitShipmentFlagFun = createSelector(selectShippingDataFun, (shippingData) => {
  // eslint-disable-next-line no-prototype-builtins
  if (shippingData?.hasOwnProperty('lineLevelSplitShipment')) {
    return shippingData.lineLevelSplitShipment;
  }
  return false;
});

export const getLineLevelshipTogetherPrefFlagFun = createSelector(selectShippingDataFun, (shippingData) => {
  // eslint-disable-next-line no-prototype-builtins
  if (shippingData?.hasOwnProperty('shipTogetherPref')) {
    return shippingData.shipTogetherPref;
  }
  return false;
});
